// extracted by mini-css-extract-plugin
export default {"container":"navigation-bar_container__uMhCw","trailingContent":"navigation-bar_trailingContent__T-W81"};